import { EditCurrentLocation } from './LocationEditTypes';
import { useCreateLocation } from './useCreateLocation';
import { ExtendedLocation } from '~/Screens/Settings/ProviderLocations/LocationEdit/ExtendedLocation.model';
import { useRequestUploadImages } from '~/requests/coreService/useRequestUploadImages';

export const useCopyLocation = (currentLocation: EditCurrentLocation) => {
  const { uploadImagesFromUrl } = useRequestUploadImages();
  const { createLocation } = useCreateLocation();

  const uploadImagesHandler = async () => {
    const images =
      currentLocation.images?.map((image) => image.imageOriginalUrl || image.imageUrl) || [];
    const imagesUploaded = await uploadImagesFromUrl(images);

    const updatedLocation = {
      ...currentLocation,
      images:
        imagesUploaded?.map((image, index) => ({
          imageUrl: image?.url,
          imageOriginalUrl: image?.imageOriginalUrl,
          order: currentLocation.images?.[index]?.order ?? index + 1,
        })) || [],
    };
    return updatedLocation;
  };

  const copyLocation = async (setIsLoading: (isLoading: boolean) => void) => {
    try {
      const updatedLocation = await uploadImagesHandler();
      await createLocation({ currentLocation: updatedLocation as ExtendedLocation, setIsLoading });
    } catch (error) {
      console.warn(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    copyLocation,
  };
};
